export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Succès"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
}